import { Dropzone } from "dropzone";

Dropzone.autoDiscover = false;
